import { gql, useMutation } from '@apollo/client';

import { GET_EMPLOYEE_QUESTIONNAIRES_FOR_TABLE } from './get-employee-questionnaires.hook';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

export const RESEND_QUESTIONNAIRES_DOCUMENT = gql`
  mutation resendEmployeeQuestionnaireLink($id: String!) {
    resendEmployeeQuestionnaireLink(id: $id) {
      _id
    }
  }
`;

export const useResendEmployeeQuestionnaireLink = ({ onSuccess }: { onSuccess?: () => void }) => {
  const [resendEmployeeQuestionnaireLink] = useMutation(RESEND_QUESTIONNAIRES_DOCUMENT, {
    refetchQueries: [GET_EMPLOYEE_QUESTIONNAIRES_FOR_TABLE],
    onCompleted: data => {
      if (data) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: 'Successful sent',
        });
      }
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: ({ graphQLErrors = [] }: { graphQLErrors?: any }) => {
      const [error] = graphQLErrors || [];

      return showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.error,
        message: 'Error',
        description: error?.message || error?.description,
      });
    },
  });

  return resendEmployeeQuestionnaireLink;
};
